import React, { useState, useEffect } from 'react'
import { default as turfPolygon } from '@turf/area'
import { default as turfLine } from '@turf/length'
import { polygon } from '@turf/helpers'
import { lineString } from '@turf/helpers'

import CloseIcon from '@material-ui/icons/Close'

import './drawingTools.css'

function ClickMenu(props) {
  const [lbl, setLbl] = useState('')
  const [lblPerimeter, setLblPerimeter] = useState('')
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')

  useEffect(() => {
    // setValues(props.clickInfo.coordinates)
    if (props.clickInfo.type === 'LineString') {
      setLbl(turfLine(lineString(props.clickInfo.coordinates), { units: 'kilometers' }).toFixed(2) + ' km')
      setLblPerimeter('')
    } else if (props.clickInfo.type === 'Polygon') {
      setLblPerimeter(turfLine(lineString(props.clickInfo.coordinates), { units: 'kilometers' }).toFixed(2) + ' km')
      if (props.units === 'km2') {
        setLbl(
          Intl.NumberFormat('en-US').format(
            (turfPolygon(polygon([props.clickInfo.coordinates])).toFixed(2) / 1) * Math.pow(10, -6),
          ) + '  km2',
        )
      }
      if (props.units === 'ha') {
        setLbl(
          Intl.NumberFormat('en-US').format(turfPolygon(polygon([props.clickInfo.coordinates])).toFixed(2) / 10000) +
            '  ha',
        )
      }
      if (props.units === 'm2') {
        setLbl(
          Intl.NumberFormat('en-US').format(turfPolygon(polygon([props.clickInfo.coordinates])).toFixed(2)) + '  m2',
        )
      }
    } else if (props.clickInfo.type === 'Point') setLbl('')
    setName(props.clickInfo.name)
    setDescription(props.clickInfo.description)
  }, [props.clickInfo])

  return (
    <div>
      <div style={{ color: 'black', height: '20px', display: 'flex' }}>
        <label className="on-click-title">Information</label>
        <CloseIcon
          style={{
            fontSize: '19px',
            position: 'relative',
            margin: 'auto',
            marginRight: '5px',
            cursor: 'pointer',
          }}
          onClick={() => {
            setName('')
            setDescription('')
            props.close()
          }}
        />
      </div>
      <div className="dt-measure-tag" style={props.clickInfo.type === 'Point' ? { height: '5px' } : null}>
        <div style={{ margin: 'auto', fontWeight: 'bold' }}>
          <label style={{ marginLeft: '5px' }}>
            {props.clickInfo.type === 'LineString' ? 'Distance:' : props.clickInfo.type === 'Polygon' ? 'Area:' : null}
          </label>
          <label style={{ marginLeft: '5px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{lbl}</label>
        </div>
        {props.clickInfo.type === 'Polygon' ? (
          <div style={{ margin: 'auto', fontWeight: 'bold' }}>
            <label style={{ marginLeft: '5px' }}>Perimeter:</label>
            <label style={{ marginLeft: '5px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{lblPerimeter}</label>
          </div>
        ) : null}
      </div>
      <div className="dt-onClick">
        <div style={{ display: 'flex', fontSize: '14px' }}>
          <label style={{ overflow: 'hidden', textOverflow: 'ellipsis', height: '20px' }}>
            <b>Name: </b>
            {name.trim() === '' ? props.clickInfo.type : name}
          </label>
        </div>
        <div style={{ fontSize: '14px' }}>
          <label>
            <b>Description: </b>
            {description}
          </label>
        </div>
        {/*<div style={{ fontSize: '14px' }}>
        <label><b>Description</b></label>
        <p className='dt-description'>{description}</p>
       </div>*/}
      </div>
    </div>
  )
}

ClickMenu.defaultProps = {
  name: '',
  description: '',
  type: '',
  coordinates: [[0, 0]],
}

export default ClickMenu
